export default "__VITE_ASSET__pei4U8qZ__"